import { use } from 'react';
import { PublisherContext } from '../contexts/PublisherContext';

export function usePublisher() {
  return use(PublisherContext);
}
